/**
 * Query keys for the Analytics reads.
 *
 * The financial-position key is what makes the four self-served cards cost one
 * request rather than four: each card's hook calls the same query, TanStack
 * dedupes on this key, and the cards stay independently mountable.
 */
export const AnalyticsQueryKeys = {
    all: ['analytics'] as const,
    financialPosition: (asOf: string | undefined, locale: string) =>
        [
            ...AnalyticsQueryKeys.all,
            'financial-position',
            asOf ?? 'today',
            locale,
        ] as const,
};
